module.exports = __webpack_public_path__ + "img/btn-bg.2499bdf2.png";